import { render } from "./GroupActions.vue?vue&type=template&id=17aeda49&ts=true"
import script from "./GroupActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupActions.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/GroupActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17aeda49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17aeda49', __exports__)) {
    console.log('reload')
    api.reload('17aeda49', __exports__)
  }
  
  module.hot.accept("./GroupActions.vue?vue&type=template&id=17aeda49&ts=true", () => {
    console.log('re-render')
    api.rerender('17aeda49', render)
  })

}


export default __exports__